'use client';

import React from "react";

const RotatedBlocks: React.FC = () => {
  return (
    <div id="values" className="flex flex-col w-full items-center justify-center gap-8">
      <div className="text-center flex flex-col gap-6">
        <p className="upperTitle">What Inspires Us</p>
        <h3 className="">Our Core Values</h3>
        <p className="">Guiding Principles that Shape Every Website We Build</p>
      </div>

      <div className="flex flex-wrap justify-center md:w-full xl:w-[90%] gap-12">
        <div
          className="relative flex sm:w-full md:w-[330px] lg:w-[400px] darkglass rounded-[25px] sm:h-[300px] md:h-[350px] xl:h-[420px] transform p-[25px] flex-col justify-end items-start gap-[10px] hover:rotate-0 transition-transform duration-300 rotate-[-0.89deg]"
        >
          {/* Background Image */}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2Frotatedblocksicons%2Fblueblocks1.png?alt=media&token=29936ac9-f01a-4378-8ce4-43e6aac8e2cb"
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover -z-10 opacity-50"
          />
          {/* Content */}
          <h4 className="w-full text-left subtitle">Creativity</h4>
          <p className="w-full text-left text-gray-600">
          We approach every project with fresh ideas and innovative thinking. Our designs are tailored to stand out while aligning perfectly with your brand’s identity. Creativity drives us to turn your digital dreams into stunning realities.
          </p>
        </div>
        <div
          className="relative flex sm:w-full md:w-[330px] lg:w-[400px] darkglass rounded-[25px] sm:h-[300px] md:h-[350px] xl:h-[420px] transform p-[25px] flex-col justify-end items-start gap-[10px] hover:rotate-0 transition-transform duration-300 rotate-[2.31deg]"
        >
          {/* Background Image */}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2Frotatedblocksicons%2Fblueblocks2.png?alt=media&token=f125293e-a4dc-4306-bdae-4645c1fad4ce"
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover -z-10 opacity-50"
          />
          {/* Content */}
          <h4 className="w-full text-left subtitle">Innovation</h4>
          <p className="w-full text-left text-gray-600">
          In a rapidly evolving digital landscape, we embrace cutting-edge tools and techniques to keep your brand ahead of the curve. From smart web development solutions to breakthrough marketing strategies, innovation is at the heart of everything we do.
          </p>
        </div>
        <div
          className="relative flex sm:w-full md:w-[330px] lg:w-[400px] darkglass rounded-[25px] sm:h-[300px] md:h-[350px] xl:h-[420px] transform p-[25px] flex-col justify-end items-start gap-[10px] hover:rotate-0 transition-transform duration-300 rotate-[-1.181deg]"
        >
          {/* Background Image */}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2Frotatedblocksicons%2Fblueblocks3.png?alt=media&token=f2012ff6-6b61-49f4-b8e3-1dc429cff0ef"
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover -z-10 opacity-50"
          />
          {/* Content */}
          <h4 className="w-full text-left subtitle">High Quality</h4>
          <p className="w-full text-left text-gray-600">
          We are committed to delivering exceptional results, ensuring that every project meets the highest standards of performance, usability, and aesthetics. Our meticulous attention to detail ensures your digital presence reflects excellence.
          </p>
        </div>
        <div
          className="relative flex sm:w-full md:w-[330px] lg:w-[400px] darkglass rounded-[25px] sm:h-[300px] md:h-[350px] xl:h-[420px] transform p-[25px] flex-col justify-end items-start gap-[10px] hover:rotate-0 transition-transform duration-300 rotate-[-2.91deg]"
        >
          {/* Background Image */}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2Frotatedblocksicons%2Fblueblocks4.png?alt=media&token=061babe0-0364-4de1-a9d5-1585b43ac64f"
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover -z-10 opacity-50"
          />
          {/* Content */}
          <h4 className="w-full text-left">Affordability</h4>
          <p className="w-full text-left text-gray-600">
          Great digital solutions don’t have to break the bank. We offer competitive pricing without compromising on quality, making exceptional digital experiences accessible to businesses of all sizes.
          </p>
        </div>
        <div
          className="relative flex sm:w-full md:w-[330px] lg:w-[400px] darkglass rounded-[25px] sm:h-[300px] md:h-[350px] xl:h-[420px] transform p-[25px] flex-col justify-end items-start gap-[10px] hover:rotate-0 transition-transform duration-300 rotate-[2.29deg]"
        >
          {/* Background Image */}
          <img
            src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2Frotatedblocksicons%2Fblueblocks5.png?alt=media&token=cc2cc49d-d0f4-4d09-a26d-246b5467ccbc"
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover -z-10 opacity-50"
          />
          {/* Content */}
          <h4 className="w-full text-left subtitle">Care</h4>
          <p className="w-full text-left text-gray-600">
          Your success is our priority. We treat every project with the same dedication and passion as if it were our own, creating solutions that genuinely resonate with your goals and audience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RotatedBlocks;
